import { useFieldValue } from "components/form/input/NestedField";
import TextInput from "components/form/input/TextInput";
import ApontamentoColetas from "entity/Indicador/components/apontamento/fields/ApontamentoColetas";
import ApontamentoCommonFields from "entity/Indicador/components/apontamento/fields/ApontamentoCommonFields";
import ApontamentoImages from "entity/Indicador/components/apontamento/fields/ApontamentoImages";
import ApontamentoClienteParams, {
    ApontamentoParamItem,
} from "entity/Indicador/components/apontamento/fields/ApontamentoClienteParams";
import ApontamentoAmostraParams, {
    useTipoApontamento,
} from "entity/Indicador/components/apontamento/fields/ApontamentoAmostraParams";
import ApontamentoResultado from "entity/Indicador/components/apontamento/fields/ApontamentoResultado";
import ApontamentoObservacao from "entity/Indicador/components/apontamento/fields/ApontamentoObservacao";
import { useEffect, useMemo } from "react";
import FormRow from "components/form/FormRow";
import EntitySearchInput from "components/form/EntitySearch/EntitySearchInput";
import AFC from "..";
import Insumo from "entity/Insumo";
import { useForm } from "react-final-form";
import Operador from "entity/Operador";

export default function AFCEditFields({ visita, TipoClass }) {
    const [tipo, setTipo] = useTipoApontamento();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const params = useMemo(() => visita.cliente.getParams(AFC, "Mecanizado", TipoClass), [visita.cliente]);

    const [apontamento, setApontamento] = useFieldValue();
    const form = useForm();

    useEffect(() => {
        if (tipo !== "Mecanizado") {
            setTipo("Mecanizado");
        }
    }, [setTipo, tipo]);

    useEffect(() => {
        if (apontamento) {
            // apontamento.conformidade = AFC.calcConformidade(apontamento, params);
            apontamento.conformidade = AFC.calcConformidade(apontamento, params, setApontamento);
            // form.change("conformidade", AFC.calcConformidade(apontamento, params, setApontamento))
            form.change("coletas", apontamento.coletas);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [apontamento, params]);

    return (
        <>
            <ApontamentoCommonFields visita={visita} />

            <ApontamentoAmostraParams tipoFixedValue="Mecanizado">
                <FormRow>
                    <EntitySearchInput name="insumo" label="Insumo" EntityClass={Insumo} />
                </FormRow>

                <FormRow>
                    <TextInput type="number" name="dosagemRecomendada" label="Dosagem Recomendada" />
                </FormRow>
                <FormRow>
                    <TextInput type="number" name="faixaTrabalho" label="Largura da Faixa de Trabalho" />
                </FormRow>

                <FormRow>
                    <EntitySearchInput
                        name="operador"
                        label="Operador"
                        EntityClass={Operador}
                        extraQuery={(query) => query.where("cliente.uid", "==", visita.data.cliente.uid)}
                    />
                </FormRow>
            </ApontamentoAmostraParams>

            <ApontamentoClienteParams params={params}>
                {params ? (
                    <>
                        <ApontamentoParamItem label="I. A.:">
                            ({params.intervaloMin}, {params.intervaloMax})
                        </ApontamentoParamItem>
                        <ApontamentoParamItem label="M. L. A.:">{params.metrosLinearesAmostra}</ApontamentoParamItem>
                        <ApontamentoParamItem label="M. L. H.:">{params.metrosLinearesHectare}</ApontamentoParamItem>
                        <ApontamentoParamItem label="Meta (%):">{params.meta}</ApontamentoParamItem>
                    </>
                ) : null}
            </ApontamentoClienteParams>

            <ApontamentoColetas visita={visita}>
                <TextInput type="number" name="pesagem" label="Pesagem" />
            </ApontamentoColetas>

            <ApontamentoResultado>
                <FormRow>
                    <TextInput name="afericao" label="Aferição" disabled />
                </FormRow>
                <FormRow>
                    <TextInput name="totalPesagem" label="Soma das Pesagens" disabled />
                </FormRow>
                <FormRow>
                    <TextInput name="doseMetro" label="Dose por Metro" disabled />
                </FormRow>
            </ApontamentoResultado>

            <ApontamentoObservacao />
            <ApontamentoImages visita={visita} />
        </>
    );
}
